import {ComponentHelper} from "../core/util/componentHelper";
import {Config} from "../core/config/config";
import {Helper} from "../core/util/helper";
import {HTTPService, JsonResultClass} from "../core/util/httpManager";
import {NotificationHelper} from "../core/util/notificationHelper";
import { Dialog, DialogProps } from "../core/components/dialog";
import {FieldInstance} from "../core/components/field";
import {TextBox} from "../core/components/textBox";
import {ToolBarStandardButton, ToolBarStandardButtonType} from "../core/components/toolBar";
import {FullHeightContainer} from "../core/components/FullHeighContainer";
import {Grid} from "../core/components/grid";
import { CheckBox } from "../core/components/checkBox";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import React from "react"

export default class EditQuanosUserCatalog extends React.Component<EditQuanosUserCatalogProps, EditQuanosUserCatalogState> {
    private _factory = ComponentHelper.createFactory();
    private _fullLoaded: boolean;
    private gridOptions: kendo.ui.GridOptions;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._save();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false, dialogOpen: false, currentItem: null };
    }
    
    private _setGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Id",
                    title: Helper.getTranslation("Standard.Key"),
                    width: 80
                },
                {
                    field: "DisplayName",
                    title: Helper.getTranslation("WebSMS.Quanos.DisplayName"),
                    width: 40
                },
                {
                    field: "TechnicalName",
                    title: Helper.getTranslation("WebSMS.Quanos.TechnicalName"),
                    width: 40
                },
                {
                    field: "Active",
                    title: Helper.getTranslation("WebSMS.Quanos.CatalogActive"),
                    width: 40,
                    template: "# if(data.Active) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"

                }
            ]
        };
    }
    private _getGridData = () => {
        let url = "GeneralSettingsQuanos/GetUserCatalog";
        HTTPService.get<JsonResultClass<QuanosCatalogUserViewModel[]>>(url, {user: this.props.entity.User.Name })
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "GeneralSettingsQuanos/SaveUserCatalog"
        HTTPService.post<JsonResultClass>(url, {  user: this.props.entity.User.Name, model: this.state.currentItem }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }


   

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createIdBox()}
                            {this._createDisplayNameTextBox()}
                            {this._createTechnicalNameTextBox()}
                            {this._createCheckBox()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createDisplayNameTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.DisplayName;
        props.disabled = true;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.DisplayName = value;
            this.setState({ currentItem: item });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.Quanos.DisplayName")} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
    );
    }

    private _createTechnicalNameTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.TechnicalName;
        props.disabled = true;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.TechnicalName = value;
            this.setState({ currentItem: item });
        }
        return (<FieldInstance label={Helper.getTranslation("WebSMS.Quanos.TechnicalName")} noHover={true}>
                    <TextBox {...props} />
                </FieldInstance>
        );
    }

    private _createCheckBox = () => {
        let props = this._factory.getDefaultCheckBoxProps();
        let label =  Helper.getTranslation("WebSMS.Quanos.CatalogActive");
        props.value = this.state.currentItem.Active;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.Active = value;
            this.setState({currentItem: item});
        }
        return (
            <FieldInstance label={label} noHover={true} labelStyle={{ width:"200px" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }
    
    private _createIdBox =  () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.Id;
        props.disabled = true;
        return(
            <FieldInstance label={Helper.getTranslation("Standard.Key")} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
    );
    }
    
    private _openDialog = async (dataItem: QuanosCatalogUserViewModel = null) => {
        if (!Helper.hasValue(dataItem)) {
            const id = dataItem.Id;
            dataItem = {
                Id: id.toString(),
                DisplayName: "",
                TechnicalName: "",
                Active: false
            };
        }
        this.setState({ dialogOpen: true, currentItem: { ...dataItem } })
    }

    private _createGrid = () => {

        
        const active = this.props.entity.QuanosSettings.MobileActive;

        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: active });
            let grid = (
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="generalSettings_QuanosCatalogGrid"
                    onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons}
                    onClickStandardButton={this._handleClickStandardButton}
                />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: QuanosCatalogUserViewModel) => {
        this.setState({ deleteButtonEnabled: Helper.hasValue(dataItem) })
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: QuanosCatalogUserViewModel) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
        }
    }
    componentDidMount() {
        this._setGridOptions();
        this._fullLoaded = true;
        this._getGridData();

    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface EditQuanosUserCatalogProps extends BaseComponentProps {
  
    value: {}[];
    entity: any;
}


interface EditQuanosUserCatalogState {
    dialogOpen: boolean;
    deleteButtonEnabled: boolean;
    currentItem: QuanosCatalogUserViewModel;
    gridData: QuanosCatalogUserViewModel[];
}
interface QuanosCatalogUserViewModel {
    Id: string;
    DisplayName: string;
    TechnicalName: string;
    Active: boolean;
}